export default {
      id: "education-usage",
      viewBox: "0 0 26 32",
      url: __webpack_public_path__ + "sprite.svg#education",
      toString: function () {
        return this.url;
      }
    }